if (document.querySelector("#interactive-map") !== null) {
  var stations;
  var currentOpenContent = null;
  var windowWidth = window.innerWidth;

  document
    .getElementById("interactive-map")
    .addEventListener("click", function (e) {
      if (e.target.tagName === "IMG") {
        var wrapper = document.querySelector("#interactive-map img");
        var rect = wrapper.getBoundingClientRect();
        var click_posX = rect.left + window.scrollX;
        var click_posY = rect.top + window.scrollY;
        var click_positionX = Math.floor(e.pageX - click_posX);
        var click_positionY = Math.floor(e.pageY - click_posY);
        var per_click_positionX = (click_positionX / wrapper.width) * 100;
        var per_click_positionY = (click_positionY / wrapper.height) * 100;

        console.log("-------------------------------------------------------");
        console.log("% X is " + Math.floor(per_click_positionX));
        console.log("% Y is " + Math.floor(per_click_positionY));
        console.log("-------------------------------------------------------");
      }
    });

  document.addEventListener("DOMContentLoaded", function () {
    fetch("/wp-json/wp/v2/custom_projects/?per_page=100&_embed")
      .then((response) => response.json())
      .then((data) => {
        stations = data;
        console.log(stations);

        // Filter stations based on Project Map Toggle
        const filteredStations = stations.filter((station) => {
          // Check if project_fields and project_map_toggle exist
          return (
            station.acf &&
            station.acf.project_fields &&
            station.acf.project_fields.project_map_toggle === true
          );
        });

        console.log("Filtered stations:", filteredStations);

        // Use the filtered stations for plotting icons
        plotIcons(filteredStations);
        setupEventListeners();
      })
      .catch((error) => console.error("Error fetching data:", error));

    function setupEventListeners() {
      if (windowWidth > 767) {
        document.body.addEventListener("mouseover", handleMouseOver);
      } else {
        document.body.addEventListener("click", handleClick);
      }

      // Add event listener for close buttons
      document.body.addEventListener("click", handleCloseClick);
    }

    function handleMouseOver(e) {
      if (e.target.closest(".project-marker")) {
        var marker = e.target.closest(".project-marker");
        var content = marker.nextElementSibling;

        if (currentOpenContent && currentOpenContent !== content) {
          currentOpenContent.classList.remove("open");
          currentOpenContent.classList.add("closed");
        }

        content.classList.remove("closed");
        content.classList.add("open");
        currentOpenContent = content;
      }
    }

    function handleClick(e) {
      var map_container = document.querySelector(".interactive-map-container");
      var map_image = document.querySelector(".interactive-map__image-wrapper");
      if (e.target.closest(".project-marker")) {
        var marker = e.target.closest(".project-marker");
        document.querySelectorAll(".project-marker").forEach((el) => {
          el.classList.remove("marker-active");
        });
        marker.classList.add("marker-active");
        var content = marker.nextElementSibling;
        if (content.classList.contains("closed")) {
          document.querySelectorAll(".project-content").forEach((el) => {
            el.classList.remove("open");
            el.classList.add("closed");
          });
          var mapHeight = map_image.offsetHeight;
          var ContentHeight = content.offsetHeight;
          map_container.style.height =
            mapHeight + ContentHeight + 96.15 + "px";

          console.log("mapHeight is " + mapHeight);
          console.log("ContentHeight is " + ContentHeight);
          console.log("Final Height is " + map_container.style.height);

          content.classList.remove("closed");
          content.classList.add("open");
        } else {
          content.classList.remove("open");
          content.classList.add("closed");
        }
      }
    }

    function handleCloseClick(e) {
      if (windowWidth > 767) {
        if (e.target.classList.contains("close-button")) {
          var content = e.target.closest(".project-content");
          content.classList.remove("open");
          content.classList.add("closed");
        }
  
      } else {
        if (e.target.classList.contains("close-button")) {
          var map_container = document.querySelector(".interactive-map-container");
          var map_image = document.querySelector(".interactive-map__image-wrapper");
          var mapHeight = map_image.offsetHeight;
          var content = e.target.closest(".project-content");
          content.classList.remove("open");
          content.classList.add("closed");
          map_container.style.height =
          mapHeight + 0 + 108.15 + "px";
        }
      }
    }
  });

  function plotIcons(data) {
    var wrapper = document.querySelector(
      "#interactive-map .interactive-map__image-wrapper"
    );
    var clusters = clusterMarkers(data);
    clusters = repositionClusters(clusters);

    clusters.forEach(function (cluster) {
      var clusterX = cluster.x;
      var clusterY = cluster.y;
      var combinedContent = "";

      cluster.posts.forEach(function (post) {
        var ArchiveData = post.acf.disable_project_archive;
        var locationData = post.acf.project_fields;
        var project_category =
          post._embedded["wp:term"] && post._embedded["wp:term"][0]
            ? post._embedded["wp:term"][0][0].name
            : "";
        var name = post.title.rendered;
        var location = locationData.project_location;

        combinedContent += `
          <div class="cluster-row">
            <div class="cluster-col project-logo">
              <svg width="25" height="25" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="Group 476">
                <ellipse id="Ellipse 1" cx="20.6093" cy="20.7284" rx="20.2265" ry="20.2266" fill="#FDD725"/>
                  <g id="Subtract">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M24.1779 8.73574C28.4041 9.61284 26.2493 14.5483 24.8041 16.3949C25.7194 18.7071 27.4439 24.3431 27.02 28.3894C26.4902 33.4474 21.1432 33.062 18.831 32.6285C16.5189 32.1949 13.3962 31.1898 11.5091 26.6071C9.82305 22.5126 12.0069 17.9042 13.436 15.7205C15.3628 12.6857 19.0719 7.67604 24.1779 8.73574ZM16.0963 20.3464C16.0192 23.1596 19.4361 21.1011 21.1542 19.7202C21.2184 19.7202 21.2216 20.5776 20.7206 24.0073C20.0944 28.2945 15.2966 26.6567 13.447 24.1518C11.1717 21.0704 13.8878 16.7297 14.8929 15.1233L14.9403 15.0476C15.9037 13.5061 20.4798 7.91833 23.5146 9.45981C26.2549 10.8517 25.2006 13.7309 24.3817 14.9031C24.3656 14.7746 24.1697 14.0457 23.5146 12.1574C22.6957 9.797 20.9616 10.5196 19.9982 11.4348C19.0348 12.3501 16.1927 16.8299 16.0963 20.3464ZM21.1387 12.9767V17.6493C20.8176 17.9544 19.867 18.632 18.6339 18.9017C19.0192 17.6172 20.0597 14.6338 21.1387 12.9767Z" fill="url(#paint0_linear_377_9678)"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M24.1779 8.73574C28.4041 9.61284 26.2493 14.5483 24.8041 16.3949C25.7194 18.7071 27.4439 24.3431 27.02 28.3894C26.4902 33.4474 21.1432 33.062 18.831 32.6285C16.5189 32.1949 13.3962 31.1898 11.5091 26.6071C9.82305 22.5126 12.0069 17.9042 13.436 15.7205C15.3628 12.6857 19.0719 7.67604 24.1779 8.73574ZM16.0963 20.3464C16.0192 23.1596 19.4361 21.1011 21.1542 19.7202C21.2184 19.7202 21.2216 20.5776 20.7206 24.0073C20.0944 28.2945 15.2966 26.6567 13.447 24.1518C11.1717 21.0704 13.8878 16.7297 14.8929 15.1233L14.9403 15.0476C15.9037 13.5061 20.4798 7.91833 23.5146 9.45981C26.2549 10.8517 25.2006 13.7309 24.3817 14.9031C24.3656 14.7746 24.1697 14.0457 23.5146 12.1574C22.6957 9.797 20.9616 10.5196 19.9982 11.4348C19.0348 12.3501 16.1927 16.8299 16.0963 20.3464ZM21.1387 12.9767V17.6493C20.8176 17.9544 19.867 18.632 18.6339 18.9017C19.0192 17.6172 20.0597 14.6338 21.1387 12.9767Z" fill="#DA1043"/>
                  </g>
              </g>
              <defs>
              <linearGradient id="paint0_linear_377_9678" x1="22.2175" y1="12.9746" x2="18.412" y2="29.449" gradientUnits="userSpaceOnUse">
              <stop stop-color="#FA6739"/>
              <stop offset="1" stop-color="#FDD725"/>
              </linearGradient>
              </defs>
            </svg>
            
            </div>
            <div class="cluster-col project-info">
              <p class="project-category">${project_category}</p>
              <p class="project-name">${name}</p>
              <p class="project-info">${location}</p>
              ${
                !ArchiveData
                  ? `
              <a class="project-href" href="${post.link}">
                <p class="project-link">See More</p>
              </a>
            `
                  : ""
              }
            </div>
          </div>
        `;
      });

      createMarker(clusterX, clusterY, combinedContent, cluster.posts.length);
    });
  }

  function clusterMarkers(data) {
    var distanceThreshold = 0;
    if (windowWidth > 767) {
      distanceThreshold = 2.05;
    } else {
      distanceThreshold = 6;
    }

    const clusters = [];

    data.forEach(function (post) {
      var locationData = post.acf.project_fields;
      var markerX = parseFloat(locationData.project_x_coordinates);
      var markerY = parseFloat(locationData.project_y_coordinates);
      var addedToCluster = false;

      for (let cluster of clusters) {
        var distance = Math.sqrt(
          Math.pow(markerX - cluster.x, 2) + Math.pow(markerY - cluster.y, 2)
        );

        if (distance < distanceThreshold) {
          cluster.posts.push(post);

          // Update cluster center
          cluster.x =
            (cluster.x * (cluster.posts.length - 1) + markerX) /
            cluster.posts.length;
          cluster.y =
            (cluster.y * (cluster.posts.length - 1) + markerY) /
            cluster.posts.length;
          addedToCluster = true;
          break;
        }
      }

      if (!addedToCluster) {
        clusters.push({ x: markerX, y: markerY, posts: [post] });
      }
    });

    return clusters;
  }

  function repositionClusters(clusters) {
    // 1. Reduced the minDistance values for both desktop and mobile.
    // 2. Changed the requiredDistance calculation to divide by 200 instead of 2, which will significantly reduce the separation distance.
    // 3. When moving clusters apart, we now multiply the moveDistance by 0.5, which will make the movement more subtle.
    var minDistance = 0;
    var maxIterations = 0;
    var baseSize = windowWidth > 767 ? 25 : 18;

    if (windowWidth > 767) {
      minDistance = 4.5; // Reduced from 6
      maxIterations = 10;
    } else {
      minDistance = 10; // Reduced from 8
      maxIterations = 10;
    }

    for (let iteration = 0; iteration < maxIterations; iteration++) {
      let moved = false;
      for (let i = 0; i < clusters.length; i++) {
        for (let j = i + 1; j < clusters.length; j++) {
          let dx = clusters[j].x - clusters[i].x;
          let dy = clusters[j].y - clusters[i].y;
          let distance = Math.sqrt(dx * dx + dy * dy);

          // Calculate the minimum required distance based on cluster sizes
          let sizeI = Math.min(baseSize + (clusters[i].posts.length - 1), 40);
          let sizeJ = Math.min(baseSize + (clusters[j].posts.length - 1), 40);
          let requiredDistance = (sizeI + sizeJ) / 200 + minDistance; // Divided by 200 instead of 2

          if (distance < requiredDistance) {
            let angle = Math.atan2(dy, dx);
            let moveDistance = (requiredDistance - distance) / 2;

            // Move clusters apart, but with less force
            clusters[i].x -= Math.cos(angle) * moveDistance * 0.5;
            clusters[i].y -= Math.sin(angle) * moveDistance * 0.5;
            clusters[j].x += Math.cos(angle) * moveDistance * 0.5;
            clusters[j].y += Math.sin(angle) * moveDistance * 0.5;

            // Ensure clusters stay within bounds (0-100)
            clusters[i].x = Math.max(0, Math.min(100, clusters[i].x));
            clusters[i].y = Math.max(0, Math.min(100, clusters[i].y));
            clusters[j].x = Math.max(0, Math.min(100, clusters[j].x));
            clusters[j].y = Math.max(0, Math.min(100, clusters[j].y));

            moved = true;
          }
        }
      }
      if (!moved) break;
    }

    return clusters;
  }

  function createMarker(x, y, content, clusterSize) {
    var wrapper = document.querySelector(
      "#interactive-map .interactive-map__image-wrapper"
    );
    var posX = x + "%";
    var posY = y + "%";
    var markerX = x;
    var markerY = y;
    var mobileClass = "normal";

    // Calculate icon size based on cluster size
    var baseSize = windowWidth > 767 ? 25 : 18;
    var maxSize = windowWidth > 767 ? 40 : 30;
    var clusterIconSize = Math.min(baseSize + (clusterSize - 1) * 2, maxSize);

    // Calculate font size based on cluster size
    var baseFontSize = 14;
    var maxFontSize = 14;
    var fontSize = Math.min(baseFontSize + (clusterSize - 0), maxFontSize);

    // Determine alignment classes
    if (markerX > 17 && markerX < 83) {
      if (markerX > 50) {
        xClass = "right-align";
        yClass = markerY > 50 ? "top-align" : "bottom-align";
      } else {
        xClass = "left-align";
        yClass = markerY > 50 ? "top-align" : "bottom-align";
      }
    } else if (markerX <= 16) {
      xClass = "right-align";
      mobileClass = "right-mobile";
      yClass = markerY > 50 ? "top-align" : "bottom-align";
    } else {
      xClass = "left-align";
      mobileClass = "left-mobile";
      yClass = markerY > 50 ? "top-align" : "bottom-align";
    }

    var marker = document.createElement("div");
    if (clusterSize == 1) {
      marker.innerHTML = `
        <div class="project-marker" style="top:${posY};left:${posX};">
          <svg width="${clusterIconSize}" height="${clusterIconSize}" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Group 476">
          <ellipse id="Ellipse 1" cx="20.6093" cy="20.7284" rx="20.2265" ry="20.2266" fill="#FDD725"/>
          <g id="Subtract">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M24.1779 8.73574C28.4041 9.61284 26.2493 14.5483 24.8041 16.3949C25.7194 18.7071 27.4439 24.3431 27.02 28.3894C26.4902 33.4474 21.1432 33.062 18.831 32.6285C16.5189 32.1949 13.3962 31.1898 11.5091 26.6071C9.82305 22.5126 12.0069 17.9042 13.436 15.7205C15.3628 12.6857 19.0719 7.67604 24.1779 8.73574ZM16.0963 20.3464C16.0192 23.1596 19.4361 21.1011 21.1542 19.7202C21.2184 19.7202 21.2216 20.5776 20.7206 24.0073C20.0944 28.2945 15.2966 26.6567 13.447 24.1518C11.1717 21.0704 13.8878 16.7297 14.8929 15.1233L14.9403 15.0476C15.9037 13.5061 20.4798 7.91833 23.5146 9.45981C26.2549 10.8517 25.2006 13.7309 24.3817 14.9031C24.3656 14.7746 24.1697 14.0457 23.5146 12.1574C22.6957 9.797 20.9616 10.5196 19.9982 11.4348C19.0348 12.3501 16.1927 16.8299 16.0963 20.3464ZM21.1387 12.9767V17.6493C20.8176 17.9544 19.867 18.632 18.6339 18.9017C19.0192 17.6172 20.0597 14.6338 21.1387 12.9767Z" fill="url(#paint0_linear_377_9678)"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M24.1779 8.73574C28.4041 9.61284 26.2493 14.5483 24.8041 16.3949C25.7194 18.7071 27.4439 24.3431 27.02 28.3894C26.4902 33.4474 21.1432 33.062 18.831 32.6285C16.5189 32.1949 13.3962 31.1898 11.5091 26.6071C9.82305 22.5126 12.0069 17.9042 13.436 15.7205C15.3628 12.6857 19.0719 7.67604 24.1779 8.73574ZM16.0963 20.3464C16.0192 23.1596 19.4361 21.1011 21.1542 19.7202C21.2184 19.7202 21.2216 20.5776 20.7206 24.0073C20.0944 28.2945 15.2966 26.6567 13.447 24.1518C11.1717 21.0704 13.8878 16.7297 14.8929 15.1233L14.9403 15.0476C15.9037 13.5061 20.4798 7.91833 23.5146 9.45981C26.2549 10.8517 25.2006 13.7309 24.3817 14.9031C24.3656 14.7746 24.1697 14.0457 23.5146 12.1574C22.6957 9.797 20.9616 10.5196 19.9982 11.4348C19.0348 12.3501 16.1927 16.8299 16.0963 20.3464ZM21.1387 12.9767V17.6493C20.8176 17.9544 19.867 18.632 18.6339 18.9017C19.0192 17.6172 20.0597 14.6338 21.1387 12.9767Z" fill="#DA1043"/>
          </g>
          </g>
          <defs>
          <linearGradient id="paint0_linear_377_9678" x1="22.2175" y1="12.9746" x2="18.412" y2="29.449" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FA6739"/>
          <stop offset="1" stop-color="#FDD725"/>
          </linearGradient>
          </defs>
          </svg>
        </div>
        
        <div class="project-content single-marker-content closed ${xClass} ${yClass} ${mobileClass}" style="top:${posY};left:${posX};">
        <button class="close-button">&times</button>
        ${content}
        </div>
      `;
    } else {
      marker.innerHTML = `
        <div class="project-marker" style="top:${posY};left:${posX};">
          <svg width="${clusterIconSize}" height="${clusterIconSize}" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
            <circle cx="15" cy="15" r="15" fill="#FDD725"/>
            <text x="15" y="20" font-family="Red Hat Display, sans-serif" font-weight="700" font-size="${fontSize}" fill="#da1043" text-anchor="middle">${clusterSize}</text>
          </svg>
        </div>
        <div class="project-content closed ${xClass} ${yClass} ${mobileClass}" style="top:${posY};left:${posX};">
        <button class="close-button">&times</button>  
        ${content}
        </div>
      `;
    }

    wrapper.appendChild(marker);

    if (window.innerWidth < 768) {
      const firstMarker = document.querySelector(".project-marker");
      if (firstMarker) {
        firstMarker.click();
      }
    }
  }
}
